import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import AudioPlayer from "react-h5-audio-player";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { richTextRenderOptions } from "../components/rendering";
import "/static/rhap.css";

const Hero = ({ audio, image, title, link, content, imageHeight = "full" }) => {
  let imageWidth = "w-7/8"
  let imageSizeClasses = `object-contain h-${imageHeight} ${imageWidth}`;
  let transition =
    "transition  ease-in-out hover:-translate-y-1 hover:scale-105 duration-300";
  const audioTrackList = audio?.map((a) => {
    return {
      // string - path to audio file, required
      src: a.file.url,

      // string - 'none' | 'metadata' | 'auto', default: 'auto', optional
      preload: "auto",
      duration: 50,
      mediaMetadata: {
        title: a.file.title,
        artist: "madi",
        album: title,
      },
    };
  });

  let getImage = (image) => {
    if (image?.file?.contentType.includes("gif")) {
      return link ? (
        <a href={link} target="_blank" rel="noreferrer">
          <img
            className={`${imageSizeClasses} ${transition}`}
            src={image.file.url}
            alt={image.title}
          />
        </a>
      ) : (
        <img src={image.file.url} alt={image.title} />
      );
    }

    if (image?.gatsbyImage) {
      return link ? (
        <a className="" href={link} target="_blank" rel="noreferrer">
          <GatsbyImage
            className={`${imageSizeClasses} ${transition}`}
            alt={image.title}
            image={image.gatsbyImage}
          />
        </a>
      ) : (
        <GatsbyImage alt={image.title} image={image.gatsbyImage} />
      );
    }
  };

  return (
    <div
      data-component-name="Hero"
      className="animate-fadeLoadSlow whitespace-normal w-full sm:mt-12 md:mt-20"
    >
      <div className="w-full">
        <div className={`hero-image   ${image ? `h-${imageHeight}` : ""}`}>
          {image && getImage(image)}
        </div>
        {audio && (
          <div className={`${imageWidth}`}>
            <AudioPlayer
              loop={true}
              src={audioTrackList[0].src}
              onDidMount={console.log}
              defaultState={{
                isMuted: false,
                activeIndex: 0,
                isShuffleOn: false,
                isTrackListOpen: false,
                // string: 'none' | 'all' | 'one' - repeating state, optional, default: 'none'
                repeatingState: "none",
              }}
            />
          </div>
        )}
      </div>
      <div className="w-full mt-12">
        {link ? (
          <a href={link} target="_blank" rel="noreferrer">
            <h1 className="text-2xl md:text-4xl uppercase">{title}</h1>
          </a>
        ) : (
          <h1 className="text-2xl md:text-4xl uppercase">{title}</h1>
        )}
        {content && (
          <div className="w-full mt-8">
            {typeof content === "string" ? (
              <div className="md:text-3xl">{content}</div>
            ) : (
              renderRichText(content, richTextRenderOptions())
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Hero;
